import tinymce from 'tinymce';

export const formatHTMLUsingTinyMCEFormatter = (html: string) => {
	const parser = tinymce.html.DomParser();
	return tinymce.html.Serializer().serialize(parser.parse(html));
};
